import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';
import { handleDownloadResponse } from '../../../components/common/common-functions/handle-response';
import getConfig from '../../../helpers/config';
import {
  DetyraParams,
  DetyraStudentReturn,
} from '../../../interfaces/detyra-interface';
import { getPrepareHeaders } from '../get-prepare-headers';

const { test } = getConfig();

export const detyraStudentApi = createApi({
  reducerPath: 'detyra-student',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['detyraStudent'],
  endpoints: builder => ({
    getDetyraStudent: builder.query<DetyraStudentReturn, DetyraParams>({
      query: args =>
        getCommonUrl(args, `/detyra-student/${args.id}/sipas-detyres`),
      providesTags: ['detyraStudent'],
    }),
    exportDetyraDocumentStudent: builder.query<Blob, number>({
      query: id => ({
        url: `/detyra-student/${id}/dokument`,
        responseHandler: handleDownloadResponse,
      }),
      providesTags: ['detyraStudent'],
    }),
  }),
});

export const {
  useGetDetyraStudentQuery,
  useLazyExportDetyraDocumentStudentQuery,
} = detyraStudentApi;
